// extracted by mini-css-extract-plugin
export var closeButton = "_pm-2";
export var closeButtonIcon = "_pm-3";
export var lightboxContent = "_pm-1";
export var lightboxOverlay = "_pm-0";